import { createFileRoute } from "@tanstack/react-router";
import { OfxToBeancountComponent } from "@/pages/tools/ofx-to-beancount";
import { head, loader } from "@/pages/tools/ofx-to-beancount.meta";

export const Route = createFileRoute("/($locale)/tools/ofx-to-beancount")({
  loader,
  head,
  component: OfxToBeancountComponent,
});
